import { DeliveryDetailDto, GetDeliveriesParams, GetDeliveriesResponse, UpdateDeliveryDto } from '@repo/types';
import apiClient from '@/lib/apiClient';

export const getDeliveries = async (params: GetDeliveriesParams): Promise<GetDeliveriesResponse> => {
  try {
    const response = await apiClient.get<GetDeliveriesResponse>(`/deliveries`, { params });

    return response.data;
  } catch (error) {
    console.error('❌ 배송 목록 조회 실패:', error);

    throw error;
  }
};

export const getDeliveryDetail = async (id: number): Promise<DeliveryDetailDto> => {
  try {
    const response = await apiClient.get<DeliveryDetailDto>(`/deliveries/${id}`);

    return response.data;
  } catch (error) {
    console.error('❌ 배송 상세 조회 실패:', error);

    throw error;
  }
};

export const patchDelivery = async (id: number, dto: UpdateDeliveryDto): Promise<DeliveryDetailDto> => {
  try {
    const response = await apiClient.patch<DeliveryDetailDto>(`/deliveries/${id}`, dto);

    return response.data;
  } catch (error) {
    console.error('❌ 배송 정보 수정 실패:', error);

    throw error;
  }
};
